module.exports = __webpack_public_path__ + "media/images/logo-sp-c291f42e6a7e5e31d2056944c5ec228d.png";